var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-c"},[_vm._v("支付成功")]),_c('van-icon',{attrs:{"name":"passed","color":"#07c160","size":"60"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }